import axios from 'axios';
import { END_TUTORIAL } from './constants';

export function endTutorial(featureName, params) {
  return axios.put(END_TUTORIAL, featureName, {
    params,
    withCredentials: true,
  });
}
